<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form enctype="multipart/form-data">
          <div class="my-5"></div>
          <div class="row justify-content-center" v-for="document in documentTypes"  :key="document.id">
            <div class="col-sm-7" >
              <div class="form-group">
                <label for="dniDocument">{{document.name}}</label> {{document.description?"(" + document.description +")":""}}<br>
                <span class="">
                  <input
                    style=""
                    type="file"
                    ref="file"
                    accept="application/pdf, image/jpeg, image/jpg, image/png"
                    @change="onFilePicked($event,document.id)"
                    :multiple="document.multiple_files"
                    :required="document.required"
                    id="uploadFile"
                  >
                 <!--  <button class="" @click="$refs.file.click()">open file dialog</button> -->
                </span>
                <div style="padding-top:10px" v-if="document.required"><i>*Es obligatorio adjuntar un archivo</i></div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTPFront } from '../../share';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import FileInput from "vue-simple-file-input";
import { createLogger } from 'vuex';

export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      documentTypes : null,
      documentMap : [],
      item: {
        dniDocument: null,
        analyticalDocument: null,
      },
      count : null,
      isDocumentRequired : false,
      lastKey : ''
    };
  },
  components: {
    FileInput,
  },
  validations: {
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          // Formulario válido
          this.$store.commit("setStepFourData", this.documentMap);
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.item.$touch();
      }
    },
  },
  created () {
    this.getDocumentTypes();
    this.countRequiredDocuments(this.documentTypes);
  },
  mounted() {
    
  if (!this.$v.$invalid && this.count == 0) {
      // Formulario válido
      this.$store.commit("setStepFourData", this.documentMap);
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }  
  },
  methods : {
    getDocumentTypes(){
      let formType = this.$route.params.call.form_type.id;
      this.documentTypes = this.$route.params.call.documentTypes;
    },
    countRequiredDocuments(documentTypes){
      this.count = 0;
      this.document = '';
      this.documentRequired = '';
      documentTypes.forEach(document =>{
        this.documentRequired = document.required;
        if(this.documentRequired == true)
        {
          this.count++;
          this.isDocumentRequired = true
        }       
      })
    },
    
    handleFileUpload(document,file){
      this.documentMap[document.id] = file;
    },
    clearDocuments(){
      this.$emit("can-continue", { value: true })
      if(this.isDocumentRequired)
      {
        this.count ++;
        this.lastKey = ''
        this.$emit("can-continue", { value: false })
      }
    },
    
    onFilePicked (e,key) {
      this.fileName = ''
      this.file = '';
      const files = e.target.files;
			if(files.length) {
        this.documentMap[key] = []
        files.forEach(file=>{
          this.documentMap[key] = []
          this.fileName = file.name
          const fr = new FileReader ()
          fr.readAsDataURL(file)
          fr.addEventListener('load', () => {
            if(!this.documentMap[key]){
              this.documentMap[key] = [];
            }
            this.documentMap[key].push(file);
          })
        })
        if(e.srcElement.required && this.count > 0 && key != this.lastKey)
        {
          this.count --;
        }
         if(!this.lastKey)
        {
          this.lastKey = key
        } 
      } 
      else {
        this.clearDocuments()
      }
       if(e.srcElement.required && this.count == 0){
         this.$store.commit("setStepFourData", this.documentMap);
         this.$emit("can-continue", { value: true });
    }
    }

  }

};

</script>
<style>

.btn-file {
    position: relative;
    overflow: hidden;
}
.btn-file input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    background: white;
    cursor: inherit;
    display: block;
}
</style>